import { adminGroups } from './routes';

export default [
  {
    id: 'contract-phase-in',
    name: 'Verträge einphasen',
    component: () => import('@/components/tools/ContractPhaseIn.vue'),
    auth: [...adminGroups, 'LgSpotAuftragsmanagement', 'LgSpotHotline', 'LgSpotVertrieb', 'LgSpotAccess', 'LgSpotSecondLevel'],
    icon: 'mdi-file-edit',
    width: '750px',
    colorScheme: 'primary'
  },
  {
    id: 'ocs-number-block',
    name: 'oCS Rufnummernblöcke',
    component: () => import('@/components/tools/OcsNumberBlockList.vue'),
    auth: [...adminGroups, 'LgSpotVoice'],
    icon: 'mdi-phone-log-outline',
    width: '80%',
    colorScheme: 'primary'
  },
  {
    id: 'activation-date-cutoff',
    name: 'Aktivierungsdatum reduzieren',
    component: () => import('@/components/tools/SetActivationDateCutoff.vue'),
    auth: [...adminGroups],
    icon: 'mdi-calendar-outline',
    width: '850px',
    colorScheme: 'primary'
  }
];
